import type { ColorPickerProps } from 'react-best-gradient-color-picker';

import { useState } from 'react';
import ColorPicker from 'react-best-gradient-color-picker';

import { Popover, PopoverContent, PopoverTrigger } from './popover';

export type ColorGradientPickerProps = Omit<ColorPickerProps, 'onChange'> & {
    name: string;
    value: string;
    className?: string;
    onChange: (color: string) => void;
};

/**
 * @deprecated use @connected/form-field-v2/form/gradient-picker instead
 */
export function ColorGradientPicker({ name, value, onChange }: ColorGradientPickerProps) {
    const [open, setOpen] = useState(false);

    const serializedValue = value?.replaceAll(';', '')?.length ? value.replaceAll(';', '') : 'rgba(255,255,255,1)';

    return (
        <div className="flex flex-col w-full  gap-2">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger>
                    <div
                        className="w-full h-10 rounded-md border border-input bg-background p-2 flex items-center justify-between cursor-pointer"
                    >
                        <div
                            className="h-full w-full rounded-md"
                            style={{
                                background: serializedValue,
                            }}
                        />
                    </div>
                </PopoverTrigger>
                <PopoverContent
                    className="flex flex-col gap-1 min-w-fit"
                >
                    <ColorPicker
                        key={name}
                        value={serializedValue}
                        onChange={onChange}
                        disableDarkMode={true}
                    />
                </PopoverContent>
            </Popover>

        </div>
    );
}
ColorGradientPicker.displayName = 'ColorGradientPicker';
